var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 46,
    viewBox: "0 0 144 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1351 22.9006C50.0767 22.6787 50.2441 22.4615 50.4736 22.4615H53.754C53.9155 22.4615 54.0559 22.5719 54.0941 22.7288L55.856 29.9702C55.9426 30.3263 56.449 30.3266 56.536 29.9706L58.3075 22.7284C58.3458 22.5717 58.4862 22.4615 58.6475 22.4615H61.5434C61.7045 22.4615 61.8448 22.5715 61.8832 22.728L63.6448 29.8932C63.7321 30.2482 64.2368 30.2485 64.3245 29.8936L66.0957 22.7275C66.1343 22.5713 66.2745 22.4615 66.4354 22.4615H69.7169C69.9464 22.4615 70.1138 22.6787 70.0554 22.9006L66.8407 35.1164C66.8003 35.2701 66.6613 35.3773 66.5023 35.3773H62.5416C62.3804 35.3773 62.2401 35.2672 62.2017 35.1107L60.4303 27.8875C60.3431 27.5318 59.8372 27.5321 59.7504 27.8879L57.9886 35.1103C57.9503 35.267 57.8099 35.3773 57.6485 35.3773H53.6882C53.5292 35.3773 53.3902 35.2701 53.3498 35.1164L50.1351 22.9006Z",
    fill: "#707077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2628 17.7836C72.2628 17.5903 72.4195 17.4336 72.6128 17.4336H76.0376C76.2309 17.4336 76.3876 17.5903 76.3876 17.7836V26.3571C76.3876 26.6688 76.7643 26.825 76.9849 26.6048L81.0321 22.5638C81.0977 22.4983 81.1866 22.4615 81.2794 22.4615H85.0446C85.3616 22.4615 85.5153 22.8493 85.2844 23.0665L79.8845 28.1451C79.742 28.2791 79.737 28.5039 79.8734 28.6441L85.8452 34.7833C86.061 35.0051 85.9038 35.3773 85.5943 35.3773H81.5745C81.4776 35.3773 81.385 35.3371 81.3188 35.2663L76.9933 30.6397C76.7764 30.4078 76.3876 30.5612 76.3876 30.8787V35.0273C76.3876 35.2206 76.2309 35.3773 76.0376 35.3773H72.6128C72.4195 35.3773 72.2628 35.2206 72.2628 35.0273V17.7836Z",
    fill: "#707077"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.389 17.4336C95.5823 17.4336 95.739 17.5903 95.739 17.7836V19.7936C95.739 19.9869 95.5823 20.1436 95.389 20.1436H93.4577C92.8739 20.1436 92.4668 20.2512 92.2364 20.4665C92.006 20.6741 91.8907 21.0393 91.8907 21.562V22.1115C91.8907 22.3048 92.0474 22.4615 92.2407 22.4615H95.0664C95.2597 22.4615 95.4164 22.6182 95.4164 22.8115V25.0637C95.4164 25.257 95.2597 25.4137 95.0664 25.4137H92.2407C92.0474 25.4137 91.8907 25.5704 91.8907 25.7637V35.0273C91.8907 35.2206 91.734 35.3773 91.5407 35.3773H88.116C87.9227 35.3773 87.766 35.2206 87.766 35.0273V25.7637C87.766 25.5704 87.6093 25.4137 87.416 25.4137H86.0651C85.8718 25.4137 85.7151 25.257 85.7151 25.0637V22.8115C85.7151 22.6182 85.8718 22.4615 86.0651 22.4615H87.416C87.6093 22.4615 87.766 22.3048 87.766 22.1115V21.562C87.766 20.1551 88.1577 19.1173 88.9412 18.4484C89.7247 17.7719 90.9383 17.4336 92.582 17.4336H95.389Z",
    fill: "#707077"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.958 25.1023C102.044 25.1023 101.345 25.4329 100.861 26.0941C100.385 26.7476 100.147 27.6932 100.147 28.931C100.147 30.1687 100.385 31.1182 100.861 31.7793C101.345 32.4328 102.044 32.7596 102.958 32.7596C103.857 32.7596 104.544 32.4328 105.02 31.7793C105.497 31.1182 105.735 30.1687 105.735 28.931C105.735 27.6932 105.497 26.7476 105.02 26.0941C104.544 25.4329 103.857 25.1023 102.958 25.1023ZM102.958 22.1502C105.178 22.1502 106.91 22.7498 108.154 23.9491C109.406 25.1485 110.032 26.8091 110.032 28.931C110.032 31.0528 109.406 32.7134 108.154 33.9128C106.91 35.1121 105.178 35.7117 102.958 35.7117C100.73 35.7117 98.9869 35.1121 97.7272 33.9128C96.4751 32.7134 95.8491 31.0528 95.8491 28.931C95.8491 26.8091 96.4751 25.1485 97.7272 23.9491C98.9869 22.7498 100.73 22.1502 102.958 22.1502Z",
    fill: "#707077"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.916 25.4264C121.917 25.6832 121.649 25.8545 121.406 25.7701C121.216 25.7038 121.025 25.6503 120.835 25.6097C120.481 25.5252 120.124 25.4829 119.763 25.4829C118.703 25.4829 117.885 25.825 117.309 26.5092C116.741 27.1858 116.456 28.1583 116.456 29.4268V35.0273C116.456 35.2206 116.3 35.3773 116.106 35.3773H112.682C112.488 35.3773 112.332 35.2206 112.332 35.0273V22.8115C112.332 22.6182 112.488 22.4615 112.682 22.4615H116.106C116.3 22.4615 116.456 22.6182 116.456 22.8115V23.3659C116.456 23.7173 116.951 23.8714 117.189 23.6133C117.527 23.2476 117.89 22.956 118.277 22.7383C118.968 22.3462 119.794 22.1502 120.754 22.1502C120.892 22.1502 121.042 22.1579 121.203 22.1732C121.306 22.1781 121.438 22.1893 121.6 22.2066C121.775 22.2254 121.907 22.3743 121.907 22.5504L121.916 25.4264Z",
    fill: "#707077"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.918 24.0469C135.066 24.2798 135.42 24.3062 135.592 24.0902C136.029 23.5403 136.523 23.105 137.075 22.7844C137.797 22.3616 138.588 22.1502 139.449 22.1502C140.931 22.1502 142.06 22.6076 142.836 23.5225C143.612 24.4373 144 25.7674 144 27.5125V35.0273C144 35.2206 143.843 35.3773 143.65 35.3773H140.202C140.009 35.3773 139.852 35.2206 139.852 35.0273V28.6427C139.86 28.5427 139.863 28.4389 139.863 28.3313C139.871 28.2237 139.875 28.0699 139.875 27.87C139.875 26.9551 139.74 26.294 139.472 25.8865C139.203 25.4714 138.769 25.2638 138.17 25.2638C137.386 25.2638 136.779 25.5867 136.349 26.2325C135.927 26.8783 135.708 27.8124 135.693 29.0347V35.0273C135.693 35.2206 135.536 35.3773 135.343 35.3773H131.895C131.701 35.3773 131.545 35.2206 131.545 35.0273V28.6427C131.545 27.2127 131.422 26.294 131.176 25.8865C130.93 25.4714 130.492 25.2638 129.863 25.2638C129.071 25.2638 128.461 25.5905 128.031 26.244C127.6 26.8898 127.385 27.8162 127.385 29.0232V35.0273C127.385 35.2206 127.229 35.3773 127.035 35.3773H123.588C123.394 35.3773 123.238 35.2206 123.238 35.0273V22.8115C123.238 22.6182 123.394 22.4615 123.588 22.4615H127.035C127.229 22.4615 127.385 22.6182 127.385 22.8115V23.2347C127.385 23.5776 127.855 23.7354 128.098 23.4929C128.417 23.1733 128.76 22.9102 129.125 22.7037C129.786 22.3347 130.512 22.1502 131.303 22.1502C132.194 22.1502 132.981 22.3654 133.665 22.796C134.174 23.1168 134.592 23.5338 134.918 24.0469Z",
    fill: "#707077"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3754_56669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3259 36C19.2737 36 10.4865 17.7093 11.0236 16.8603C11.5608 16.0114 20.4169 26.0056 21.3259 26.16C22.2349 26.3143 31.9726 11.6898 34.6583 10.0688C37.3441 8.44787 23.3781 36 21.3259 36Z",
    fill: "url(#paint0_linear_3754_56669)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3754_56669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3259 36C28.2737 36 19.4865 17.7093 20.0236 16.8603C20.5608 16.0114 29.4169 26.0056 30.3259 26.16C31.2349 26.3143 40.9726 11.6898 43.6583 10.0688C46.3441 8.44787 32.3781 36 30.3259 36Z",
    fill: "url(#paint1_linear_3754_56669)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3754_56669",
    x: 0,
    y: 0,
    width: 44,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3754_56669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3754_56669",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3754_56669",
    x: 9,
    y: 0,
    width: 44,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3754_56669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3754_56669",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3754_56669",
    x1: 17.0905,
    y1: 29.1321,
    x2: 34.8324,
    y2: 10.2965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.100098,
    stopColor: "#7EB250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EB250"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3754_56669",
    x1: 26.0905,
    y1: 29.1321,
    x2: 43.8324,
    y2: 10.2965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.100098,
    stopColor: "#7EB250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EB250"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainlogo);
export default __webpack_public_path__ + "static/media/mainlogo.80ade768c245b11ecdbeea08272462b1.svg";
export { ForwardRef as ReactComponent };